export const getCompanyLogo = (fileName?: string | null) =>
  `/assets/global/img%7Ccompany-logos/${fileName}`
